/**
 * How long the softphone has been registered, as `HH:MM`.
 *
 * Zero-padded so the footer does not reflow every time an hour or a minute
 * rolls over, and capped at nothing: a registration that has been up for two
 * days reads `48:00`, which is the point.
 */
export const formatUptime = (
  registeredAt: string | null,
  now: Date
): string | null => {
  if (!registeredAt) {
    return null;
  }

  const elapsedMs = now.getTime() - new Date(registeredAt).getTime();

  if (Number.isNaN(elapsedMs) || elapsedMs < 0) {
    return null;
  }

  const totalMinutes = Math.floor(elapsedMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
